import { render, staticRenderFns } from "./storeProfile.vue?vue&type=template&id=4faa5d46&scoped=true&"
import script from "./storeProfile.vue?vue&type=script&lang=js&"
export * from "./storeProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa5d46",
  null
  
)

export default component.exports